<script lang="ts" module>
	export interface TagProps {
		selected?: boolean | undefined;
		classes?: { icon?: string };
		dataCy: string;
		onClick?: (() => void) | undefined;
		size?: ButtonProps['size'];
		class?: string;
		leading?: import('svelte').Snippet;
		children?: import('svelte').Snippet;
	}
</script>

<script lang="ts">
	import classNames from 'classnames';
	import { twMerge } from 'tailwind-merge';
	import { CrossIcon } from '../../assets/icons/CrossIcon';
	import { Button, type ButtonProps } from '../Button';

	let {
		selected = false,
		classes = {},
		dataCy,
		onClick = undefined,
		size = 'sm',
		leading,
		children,
		...rest
	}: TagProps = $props();
</script>

<Button
	class={twMerge(
		classNames('icon-xs', {
			'hover:border-gray-200 focus:border-gray-200 active:border-gray-200': !onClick
		}),
		rest.class
	)}
	{size}
	dataCy={`${dataCy}-tag`}
	variant={selected ? 'primary' : 'secondary'}
	onclick={onClick as () => void}
>
	{@render leading?.()}
	{@render children?.()}

	{#snippet trailing()}
		<span class="empty:hidden">
			{#if selected}
				<CrossIcon color="gray-0" class={twMerge(classes.icon, 'h-4 w-4')} />
			{/if}
		</span>
	{/snippet}
</Button>
